import { useEffect, useState } from "react";
import { FaCloudUploadAlt, FaDownload, FaExternalLinkAlt, FaFile, FaPlus, FaSpinner, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import Selector from "../components/ui/components/Selector";
import CopyToClipBoard from "../utils/CopyToClipBoard";
import IdButton from "../components/ui/components/IdButton";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import { FormatDateToDDMMYY } from "../utils/FormatDate";
import DetailsButton from "../components/ui/components/DetailsButton";
import Modal from "../components/ui/Modal";
import DinamicButton from "../components/ui/components/DinamicButton";
import CheckBox from "../components/ui/components/CheckBox";
import TextInput from "../components/ui/components/formComponents/TextInput";
import SelectInput from "../components/ui/components/formComponents/SelectInput";
import DateInput from "../components/ui/components/formComponents/DateInput";
import PaginationItem from "../components/ui/components/Pagination";
import DinamicBoxButton from "../components/ui/components/DinamicBoxButton";
import GenerateTxtFileBlockAssignment from "../utils/automateFuncions/GenerateTxtFileBlockAssignment";
import GenerateTxtFileAssignment from "../utils/automateFuncions/GenerateTxtFileAssignment";
import { useSelector } from "react-redux";
import ButtonInput from "../components/ui/components/formComponents/ButtonInput";

const AsignacionesBloque = () => {

  const [limit, setLimit] = useState(20)
  const [page, setPage] = useState(1)

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(1)

  const [loading, setLoading] = useState(false)
  const [record, setRecord] = useState([])

  const [workers, setWorkers] = useState([])
  const [reassignSelection, setReassignSelection] = useState({})
  const [reassigningItemId, setReassigningItemId] = useState(null)

  // Crear bloque
  const [createBlockModal, setCreateBlockModal] = useState(false)
  const [creatingBlock, setCreatingBlock] = useState(false)
  const [blockTitle, setBlockTitle] = useState("")
  const [blockUser, setBlockUser] = useState("")
  const [blockDateStart, setBlockDateStart] = useState(() => new Date().toISOString().slice(0, 10))
  const [selectedItemIds, setSelectedItemIds] = useState([])
  const [itemsPage, setItemsPage] = useState(1)
  const [itemsLimit, setItemsLimit] = useState(20)
  // Items disponibles para crear el bloque - paginador
  const [availableUnassignedItems, setAvailableUnassignedItems] = useState([])
  const [itemsTotalPages, setItemsTotalPages] = useState(1)
  const [itemsTotalDocs, setItemsTotalDocs] = useState(0)

  const [editModal, setEditModal] = useState(false)
  const [editData, setEditData] = useState({})

  const [detailsModal, setDetailsModal] = useState(false)
  const [detailsData, setDetailsData] = useState({})

  const handleEdit = (data) => {
    setEditData(data)
    setEditModal(true)
  }

  const handleDetails = (data) => {
    setDetailsData(data)
    setDetailsModal(true)
  }

  const getRecord = async () => {
    try {
      setLoading(true)
      
      const response = await axios.get(`${BACKEND}/api/populatedAsignmentBlocks?limit=${limit}&page=${page}`)
      setRecord(response.data.docs || [])
      setTotalDocs(response.data.totalDocs || 0)
      setTotalPages(response.data.totalPages || 1)

    } catch (e) {
      console.log(e)
      toast.error("Error al obtener los registros " + e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRecord()
  }, [limit, page])

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/getUsersIds/getWorkerUsers`)
      setWorkers(response.data || [])
    } catch (e) {
      console.log(e)
      toast.error("Error al obtener los usuarios")
    }
  }

  useEffect(() => {
    getWorkers()
  }, [])

  const refreshBlock = async (blockId) => {
    try {
      const response = await axios.get(`${BACKEND}/api/populatedAsignmentBlocks?limit=1&where[id][equals]=${blockId}`)
      let doc = response?.data?.docs?.[0]
      if (doc) {
        // Si todas las asignaciones están cerradas y el bloque no tiene fecha fin, cerrarlo automáticamente
        const assignments = doc.assignments || []
        const allClosed = assignments?.length > 0 && assignments?.every((a) => !!a?.dateEnd)
        if (allClosed && !doc.dateEnd) {
          const suggestedEnd = new Date(Math.max(...assignments.map(a => new Date(a.dateEnd).getTime()))).toISOString()
          try {
            const putRes = await axios.put(`${BACKEND}/api/bloquesAsignaciones/${doc.id}`, { dateEnd: suggestedEnd })
            const updatedDateEnd = putRes?.data?.doc?.dateEnd || suggestedEnd
            doc = { ...doc, dateEnd: updatedDateEnd }
            toast.success('Bloque cerrado automáticamente')
          } catch (err) {
            console.log(err)
          }
        }

        setDetailsData(doc)
        setRecord((prev) => prev.map((b) => b.id === doc.id ? doc : b))
      }
    } catch (e) {
      console.log(e)
    }
  }

  const reassignItemUser = async ({ itemId, userId, blockId }) => {
    try {
      setReassigningItemId(itemId)
      const payload = { userAssigned: userId || null, status: userId ? 'En uso' : 'Disponible' }
      await axios.put(`${BACKEND}/api/inventario/${itemId}`, payload)
      toast.success('Ítem reasignado')
      await refreshBlock(blockId)
      setReassignSelection((prev) => ({ ...prev, [itemId]: undefined }))
    } catch (e) {
      console.log(e)
      toast.error('No se pudo reasignar el ítem')
    } finally {
      setReassigningItemId(null)
    }
  }

  const loadUnassignedItems = async (page = itemsPage, limit = itemsLimit) => { // Traer los items Disponibles
    try {
      const response = await axios.get(`${BACKEND}/api/inventario?limit=${limit}&page=${page}&where[status][equals]=Disponible`)
      setAvailableUnassignedItems(response?.data?.docs || [])
      setItemsTotalPages(response?.data?.totalPages || 1)
      setItemsTotalDocs(response?.data?.totalDocs || 0)
    } catch (e) {
      console.log(e)
      toast.error('Error al cargar ítems sin asignar')
    }
  }

  const openCreateBlockModal = async () => {
    setCreateBlockModal(true)
    setSelectedItemIds([])
    await loadUnassignedItems()
  }

  const toggleSelectItem = (id) => {
    setSelectedItemIds((prev) => prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id])
  }

  const selectAllItems = () => {
    setSelectedItemIds(availableUnassignedItems.map((i) => i.id))
  }

  const clearAllItems = () => {
    setSelectedItemIds([])
  }

  const createBlockWithAssignments = async () => {
    try {
      if (!blockTitle) { toast.warning('Ingresa un título'); return }
      if (!blockUser) { toast.warning('Selecciona usuario responsable'); return }
      if (selectedItemIds?.length === 0) { toast.warning('Selecciona al menos dos ítem'); return }
      if (selectedItemIds?.length === 1) { toast.warning('Debes seleccionar al menos dos ítems para crear un bloque, si deseas asignar un solo item, edíta el ítem individualmente y asignaselo a un trabajador'); return }
      setCreatingBlock(true)
      const payload = {
        title: blockTitle,
        user: blockUser,
        dateStart: new Date(blockDateStart).toISOString(),
      }
      const res = await axios.post(`${BACKEND}/api/bloquesAsignaciones`, payload) // Creamos el bloque nuevo
      const blockId = res?.data?.doc?.id // Obtenemos el ID del bloque recién creado
      if (!blockId) throw new Error('No se obtuvo ID del bloque') // SI el bloque no se crea, cortamos flujo
      const nowIso = new Date().toISOString()
      // Colocar los ítems en estado "En uso"
      await Promise.all(selectedItemIds.map((itemId) => axios.put(`${BACKEND}/api/inventario/${itemId}?blockAssigned=${blockId}`, {
          status: 'En uso',
          userAssigned: blockUser,
        })
      ))
      toast.success('Bloque creado y asignaciones abiertas')
      setCreateBlockModal(false)
      setBlockTitle("")
      setBlockUser("")
      setSelectedItemIds([])
      await getRecord()
    } catch (e) {
      console.log(e)
      toast.error('Error al crear el bloque o las asignaciones')
    } finally {
      setCreatingBlock(false)
    }
  }

  const headers = [
    { 
      id: 1, 
      name: "Acciones", 
      show: true, 
      Cell: ({row, i}) => { 
        return (
          <div className="flex items-center gap-2 justify-center">
            <DetailsButton content="Ver bloque" action={() => handleDetails(row)} /> 
          </div>
        )
      } 
    },
    { 
      id: 2, 
      name: "ID", 
      show: true, 
      Cell: ({row, i}) => { 
        return (
          <div className="flex items-center justify-center">
            <IdButton content={row.id} action={() => CopyToClipBoard(row.id)} /> 
          </div>
        )
      } 
    },
    { 
      id: 3, 
      name: "Usuario", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex flex-row  gap-2 items-center justify-center">
            <img src={row.user.foto} alt={row.user.name} className="w-8 h-8 rounded-full" />
            <span className="text-xs uppercase">{row.user.name}</span>
          </div>
        )
      } 
    },  
    { 
      id: 4, 
      name: "Título bloque", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex items-center justify-center">
            {row.title}
          </div>
        )
      } 
    }, 
    { 
      id: 5, 
      name: "Asignaciones en el bloque", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex items-center justify-center">
            {row.assignments?.length}
          </div>
        )
      } 
    }, 
    { 
      id: 6, 
      name: "Fecha inicio", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex items-center justify-center">
            {FormatDateToDDMMYY(row.dateStart)}
          </div>
        )
      } 
    }, 
    { 
      id: 7, 
      name: "Fecha fin", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex items-center justify-center">
            {FormatDateToDDMMYY(row.dateEnd)}
          </div>
        )
      } 
    }, 
    { 
      id: 9, 
      name: "Estado", 
      show: true, 
      Cell: ({row}) => { 
        return (
          <div className="flex items-center justify-center">
            <div className={`px-3 py-1 rounded-full text-xs font-medium ${row.dateEnd ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
              {row.dateEnd ? 'Finalizado' : 'En curso'}
            </div>
          </div>
        )
      } 
    }, 
  ]

  // Estado para manejo de archivos
  const [uploadingDevolitionFile, setUploadingDevolitionFile] = useState(false)
  const [uploadingRecepcionFile, setUploadingRecepcionFile] = useState(false)

  const [deletingRecepcionFile, setDeletingRecepcionFile] = useState(false)
  const [deletingDevolutionFile, setDeletingDevolutionFile] = useState(false)

  const [assignUpdating, setAssignUpdating] = useState(null)
  const [typeUpdating, setTypeUpdating] = useState(null)

  // Subir actas por asignación (entrega/devolución)
  const handleUploadActa = async ({ block, field, files }) => {
    try {
      if (!files || files.length === 0) return
      if (field === 'actaRecepcion') setUploadingRecepcionFile(true)
      if (field === 'actaDevolucion') setUploadingDevolitionFile(true)
      setAssignUpdating(block.id)
      setTypeUpdating(field)


      let createdDoc = null

      for (const file of Array.from(files)) {
        const formData = new FormData()
        formData.append('file', file)
        const responseFile = await axios.post(`${BACKEND}/api/documentosAsignaciones`, formData)
        const createdId = responseFile?.data?.doc?.id
        if (createdId) createdDoc = createdId
      }

      const response = await axios.put(`${BACKEND}/api/bloquesAsignaciones/${block.id}`, {
        [field]: createdDoc
      })

      const updated = response?.data?.doc
      if (updated) {
        refreshBlock(updated)
      }
      toast.success('Acta subida exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo acta')
    } finally {
      if (field === 'actaRecepcion') setUploadingRecepcionFile(false)
      if (field === 'actaDevolucion') setUploadingDevolitionFile(false)
      setAssignUpdating(null)
      setTypeUpdating(null)
    }
  }

  // Eliminación de actas de bloques
  const deleteAssignmentActFile = async ({ block, field, id }) => {
    try {

      if (field === 'actaRecepcion') setDeletingRecepcionFile(true)
      if (field === 'actaDevolucion') setDeletingDevolutionFile(true)
      setAssignUpdating(block.id)
      setTypeUpdating(field)
  
      await axios.delete(`${BACKEND}/api/documentosAsignaciones/${id}`)
  
      const response = await axios.put(`${BACKEND}/api/bloquesAsignaciones/${block.id}`, {
        [field]: null
      })
  
      const updated = response?.data?.doc
      if (updated) {
        refreshBlock(updated)
      }
      toast.success('Archivo de acta eliminado')
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando archivo de acta')
    } finally {
      if (field === 'actaRecepcion') setDeletingRecepcionFile(false)
      if (field === 'actaDevolucion') setDeletingDevolutionFile(false)
      setAssignUpdating(null)
      setTypeUpdating(null)
    }
  }

  // Subir actas por asignación individual (entrega/devolución)
  const handleUploadActaIndividual = async ({ assignment, field, files }) => {
    try {
      if (!files || files.length === 0) return
      if (field === 'actaRecepcion') setUploadingRecepcionFile(true)
      if (field === 'actaDevolucion') setUploadingDevolitionFile(true)
      setAssignUpdating(assignment.id)
      setTypeUpdating(field)

      let createdDoc = null

      for (const file of Array.from(files)) {
        const formData = new FormData()
        formData.append('file', file)
        const responseFile = await axios.post(`${BACKEND}/api/documentosAsignaciones`, formData)
        const createdId = responseFile?.data?.doc?.id
        if (createdId) createdDoc = createdId
      }

      const response = await axios.put(`${BACKEND}/api/asignacionesInventario/${assignment.id}`, {
        [field]: createdDoc
      })

      const updated = response?.data?.doc
      if (updated) {
        await refreshBlock(detailsData.id)
      }
      toast.success('Acta subida exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo acta')
    } finally {
      if (field === 'actaRecepcion') setUploadingRecepcionFile(false)
      if (field === 'actaDevolucion') setUploadingDevolitionFile(false)
      setAssignUpdating(null)
      setTypeUpdating(null)
    }
  }

  // Eliminación de actas de asignaciones individuales
  const deleteIndividualAssignmentActFile = async ({ assignment, field, id }) => {
    try {
      if (field === 'actaRecepcion') setDeletingRecepcionFile(true)
      if (field === 'actaDevolucion') setDeletingDevolutionFile(true)
      setAssignUpdating(assignment.id)
      setTypeUpdating(field)
  
      await axios.delete(`${BACKEND}/api/documentosAsignaciones/${id}`)
  
      const response = await axios.put(`${BACKEND}/api/asignacionesInventario/${assignment.id}`, {
        [field]: null
      })
  
      const updated = response?.data?.doc
      if (updated) {
        await refreshBlock(detailsData.id)
      }
      toast.success('Archivo de acta eliminado')
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando archivo de acta')
    } finally {
      if (field === 'actaRecepcion') setDeletingRecepcionFile(false)
      if (field === 'actaDevolucion') setDeletingDevolutionFile(false)
      setAssignUpdating(null)
      setTypeUpdating(null)
    }
  }

  const user = useSelector((state) => state.auth.user)

  const [closingBlock, setClosingBlock] = useState(false)

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal
        activeModal={detailsModal}
        onClose={() => setDetailsModal(false)}
        title="Detalles del bloque"
        centered
        className="max-w-6xl"
      >
        <div>
          {detailsData?.id ? (
            <div className="space-y-4">
              {(() => {
                const assignments = detailsData.assignments || []
                const allClosed = assignments?.length > 0 && assignments.every((a) => !!a?.dateEnd)
                const suggestedEnd = allClosed ? new Date(Math.max(...assignments.map(a => new Date(a.dateEnd).getTime()))).toISOString() : null

                const closeBlock = async () => {
                  setClosingBlock(true)
                  let toastId = null
                  try {
                    if (detailsData.dateEnd) {
                      toast.warning('Este bloque ya está cerrado')
                      return
                    }

                    // if (!detailsData.actaRecepcion || !detailsData.actaDevolucion) {
                    //   toast.warning('Para cerrar el bloque, debes subir las actas de recepción y devolución.')
                    //   return
                    // }
                     
                    // Paso 1: Cerrar el bloque
                    toastId = toast.loading('Cerrando bloque...')
                    const payload = { dateEnd: suggestedEnd || new Date().toISOString() }
                    const url = `${BACKEND}/api/bloquesAsignaciones/${detailsData.id}`
                    const response = await axios.put(url, payload)
                    // const updatedDateEnd = response?.data?.doc?.dateEnd || payload.dateEnd
                    
                    // Paso 2: Actualizar ítems (solo de asignaciones abiertas)
                    const openAssignments = assignments.filter((a) => !a?.dateEnd)
                    toast.update(toastId, { render: `Liberando ${openAssignments.length} ítems de asignaciones abiertas...`, type: 'info', isLoading: true })
                    const itemUpdatePromises = openAssignments.map((assignment) => {
                      if (assignment?.item?.id) {
                        return axios.put(`${BACKEND}/api/inventario/${assignment.item.id}`, {
                          status: 'Disponible',
                          userAssigned: null
                        })
                      }
                      return Promise.resolve()
                    })
                    
                    await Promise.all(itemUpdatePromises)
                    
                    // Paso 3: Actualizar estado local
                    refreshBlock(detailsData.id)
                    
                    // Éxito
                    toast.update(toastId, { 
                      render: 'Bloque cerrado correctamente e ítems liberados', 
                      type: 'success', 
                      isLoading: false,
                      autoClose: 3000
                    })
                  } catch (e) {
                    console.log(e)
                    if (toastId) {
                      toast.update(toastId, { 
                        render: 'No se pudo cerrar el bloque', 
                        type: 'error', 
                        isLoading: false,
                        autoClose: 3000
                      })
                    } else {
                      toast.error('No se pudo cerrar el bloque')
                    }
                  } finally {
                    setClosingBlock(false)
                  }
                }

                return (
                  <div className="flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
                    <div className="text-xs">
                      <span className={`px-2 py-1 rounded-full font-medium ${detailsData.dateEnd || allClosed ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {detailsData.dateEnd ? 'Bloque finalizado' : (allClosed ? 'Listo para cerrar' : 'En curso')}
                      </span>
                    </div>
                    {detailsData.dateEnd ? (
                      <ButtonInput content="Bloque cerrado" color="gray" disabled={true} />
                    ) : (
                      <ButtonInput content="Cerrar bloque" onClick={closeBlock} color="red" loading={closingBlock} loadingContent="Cerrando bloque..." />
                    )}
                  </div>
                )
              })()}
              {/* Resumen del bloque */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">Resumen del bloque</h3>
                  <div className="text-xs space-y-1">
                    <div><span className="font-medium">ID:</span> <span className="select-all">{detailsData.id}</span></div>
                    <div><span className="font-medium">Título:</span> {detailsData.title || '-'}</div>
                    <div><span className="font-medium">Fecha inicio:</span> {FormatDateToDDMMYY(detailsData.dateStart)}</div>
                    <div><span className="font-medium">Fecha fin:</span> {FormatDateToDDMMYY(detailsData.dateEnd)}</div>
                    <div><span className="font-medium">Asignaciones:</span> {detailsData.assignments?.length || 0}</div>
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">Usuario responsable</h3>
                  <div className="flex items-center gap-3">
                    <img src={detailsData.user?.foto} alt={detailsData.user?.name} className="w-10 h-10 rounded-full object-cover" />
                    <div className="text-xs">
                      <div className="font-semibold uppercase">{detailsData.user?.name || '-'}</div>
                      <div className="text-gray-600">{detailsData.user?.puesto || '-'}</div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">Documentos del bloque</h3>
                  <div className="text-xs space-y-1">


                    {/* Acta de recepción */}
                    <div className="flex flex-row gap-2 items-center justify-start w-full">
                      <span className="text-xs text-gray-500">Acta de recepción</span>
                      {!detailsData?.actaRecepcion ? (
                        <>
                          <DinamicBoxButton
                            content="Descargar acta de recepción."
                            icon={<FaDownload className="text-[10px]" />}
                            color={"blue"}
                            size="sm"
                            action={() => 
                              detailsData?.assignments?.every((a) => a?.item?.media && a?.item?.media?.length > 0) ?
                              GenerateTxtFileBlockAssignment({
                                day: new Date().getDate(),
                                monthName: new Date().toLocaleString('default', { month: 'long' }),
                                year: new Date().getFullYear(),
                                assignedWorker: detailsData.user.name,
                                responsible: user.name,
                                devolutionDate: new Date(),
                                blockDateStart: detailsData.dateStart,
                                blockDateEnd: detailsData.dateEnd,
                                items: detailsData.assignments.filter((a) => !a?.dateEnd).map((a) => ({
                                  buyId: a.item?.buy?.id,
                                  buyCode: a.item?.buy?.receiptNumber,
                                  buyDate: a.item?.buy?.paymentDate,
                                  itemRegisterDate: a.item?.createdAt,
                                  product: a.item?.itemName,
                                  currency: a.item?.buy?.currency,
                                  price: a.item?.buy?.stakeholderProduct?.price,
                                  image: a.item?.media && a.item?.media?.length > 0 ? a.item?.media?.[0]?.url : '',
                                })),
                                type: "recepción",
                              }) 
                              : toast.warning('Todos los ítems del bloque deben tener al menos una imagen para generar el acta de recepción.')
                            }
                          />
                          <div>
                            <input
                              type="file"
                              id={`upload-acta-entrega-${detailsData.id}`}
                              className="hidden"
                              accept="image/*,.pdf"
                              disabled={uploadingRecepcionFile && assignUpdating === detailsData.id && typeUpdating === 'actaRecepcion'}
                              onChange={(e) => handleUploadActa({ block: detailsData, field: 'actaRecepcion', files: e.target.files })}
                            />
                            <DinamicBoxButton
                              content="Subir acta de recepción"
                              icon={uploadingRecepcionFile ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                              disabled={uploadingRecepcionFile}
                              color={uploadingRecepcionFile ? 'gray' : 'green'}
                              size="sm"
                              action={() => document.getElementById(`upload-acta-entrega-${detailsData.id}`)?.click()}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <DinamicBoxButton
                            content="Ver acta de recepción"
                            icon={<FaExternalLinkAlt className="text-[10px]" />}
                            color="blue"
                            size="sm"
                            action={() => {
                              const url = detailsData?.actaRecepcion?.url || detailsData?.actaRecepcion?.[0]?.url
                              if (url) window.open(url, '_blank')
                              else toast.info('No hay acta de recepción')
                            }}
                          />
                          <DinamicBoxButton
                            action={() => deleteAssignmentActFile({ block: detailsData, field: 'actaRecepcion', id: detailsData?.actaRecepcion?.id })}
                            content="Eliminar acta de recepción"
                            icon={deletingRecepcionFile ? <FaSpinner className="text-[10px] animate-spin" /> : <FaTrash className="text-[10px]" />}
                            disabled={deletingRecepcionFile}
                            color={deletingRecepcionFile ? 'gray' : 'red'}
                          />
                        </>
                      )}
                    </div>

                    
                    {/* Acta de devolución */}
                    <div className="flex flex-row gap-2 items-center justify-start w-full">
                      <span className="text-xs text-gray-500">Acta de devolución</span>
                      {!detailsData?.actaDevolucion ? (
                        <>
                          <DinamicBoxButton
                            content="Descargar acta de devolución."
                            icon={<FaDownload className="text-[10px]" />}
                            color={"blue"}
                            size="sm"
                            action={() => 
                              detailsData?.assignments?.every((a) => a?.item?.media && a?.item?.media?.length > 0) ?
                              GenerateTxtFileBlockAssignment({
                                day: new Date().getDate(),
                                monthName: new Date().toLocaleString('default', { month: 'long' }),
                                year: new Date().getFullYear(),
                                assignedWorker: detailsData.user.name,
                                responsible: user.name,
                                
                                devolutionDate: new Date(),
                                blockDateStart: detailsData.dateStart,
                                blockDateEnd: detailsData.dateEnd,
                                items: detailsData.assignments.filter((a) => !a?.dateEnd).map((a) => ({
                                  buyId: a.item?.buy?.id,
                                  buyCode: a.item?.buy?.receiptNumber,
                                  buyDate: a.item?.buy?.paymentDate,
                                  itemRegisterDate: a.item?.createdAt,
                                  product: a.item?.itemName,
                                  currency: a.item?.buy?.currency,
                                  price: a.item?.buy?.stakeholderProduct?.price,
                                  image: a.item?.media && a.item?.media?.length > 0 ? a.item?.media?.[0]?.url : '',
                                })),
                                type: "devolución",
                              }) 
                              : toast.warning('Todos los ítems del bloque deben tener al menos una imagen para generar el acta de devolución.')
                            }
                          />
                          <div>
                            <input
                              type="file"
                              id={`upload-acta-devolucion-${detailsData.id}`}
                              className="hidden"
                              accept="image/*,.pdf"
                              disabled={uploadingDevolitionFile && assignUpdating === detailsData.id && typeUpdating === 'actaDevolucion'}
                              onChange={(e) => handleUploadActa({ block: detailsData, field: 'actaDevolucion', files: e.target.files })}
                            />
                            <DinamicBoxButton
                              content="Subir acta de devolución"
                              icon={uploadingDevolitionFile ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                              disabled={uploadingDevolitionFile}
                              color={uploadingDevolitionFile ? 'gray' : 'green'}  
                              size="sm"
                              action={() => document.getElementById(`upload-acta-devolucion-${detailsData.id}`)?.click()}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <DinamicBoxButton
                            content="Ver acta de devolución"
                            icon={<FaExternalLinkAlt className="text-[10px]" />}
                            color="blue"
                            size="sm"
                            action={() => {
                              const url = detailsData?.actaDevolucion?.url || detailsData?.actaDevolucion?.[0]?.url
                              if (url) window.open(url, '_blank')
                              else toast.info('No hay acta de devolución')
                            }}
                          />
                          <DinamicBoxButton
                            action={() => deleteAssignmentActFile({ block: detailsData, field: 'actaDevolucion', id: detailsData?.actaDevolucion?.id })}
                            content="Eliminar acta de devolución"
                            icon={deletingDevolutionFile ? <FaSpinner className="text-[10px] animate-spin" /> : <FaTrash className="text-[10px]" />}
                            disabled={deletingDevolutionFile}
                            color={deletingDevolutionFile ? 'gray' : 'red'}
                          />
                        </>
                      )}
                    </div>


                  </div>
                </div>
              </div>

              {/* Asignaciones vinculadas */}
              <div>
                <h3 className="text-sm font-semibold text-gray-700 mb-2">Asignaciones vinculadas al bloque</h3>
                <div className="space-y-3 max-h-[55vh] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                  {detailsData.assignments?.map((a, idx) => {
                    const buy = a?.item?.buy || {};
                    const currency = buy?.currency === 'Soles' ? 'S/' : (buy?.currency || '');
                    const formatMoney = (v) => typeof v === 'number' ? v.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-';
                    return (
                      <div key={a?.id || idx} className="border border-gray-200 rounded-lg p-3">

                        {/* Encabezado de asignación */}
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                          <div className="flex items-center gap-2">
                            <img src={a?.user?.foto} alt={a?.user?.name} className="w-8 h-8 rounded-full object-cover" />
                            <div className="text-xs">
                              <div className="font-semibold uppercase">{a?.user?.name || '-'}</div>
                              <div className="text-gray-600">{a?.user?.puesto || '-'}</div>
                            </div>
                          </div>

                          <div className="text-[11px] text-gray-700 flex items-center gap-3">
                            <div className="text-xs">
                              <span className={`px-2 py-1 rounded-full font-medium ${a?.dateEnd ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                                {a?.dateEnd ? 'Asignación finalizada' : 'En curso'}
                              </span>
                            </div>
                            <div><span className="font-medium">Inicio:</span> {FormatDateToDDMMYY(a?.dateStart)}</div>
                            <div><span className="font-medium">Fin:</span> {FormatDateToDDMMYY(a?.dateEnd)}</div>
                          </div>
                        </div>

                        {a?.description && (
                          <div className="mt-2 text-xs text-gray-700">{a.description}</div>
                        )}

                        {/* Detalles de Ítem y Compra */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">

                          {/* Ítem */}
                          <div className="bg-gray-50 rounded-lg p-3">
                            <h4 className="text-xs font-semibold text-gray-700 mb-2">Ítem</h4>
                            <div className="text-[11px] space-y-1">
                              <div className="col-span-2 flex items-center gap-2">
                                <span className="font-medium">ID:</span>
                                <IdButton content={a?.item?.id || '-'} action={() => a?.item?.id && CopyToClipBoard(a.item.id)} />
                              </div>
                              <div><span className="font-medium">Nombre:</span> {a?.item?.itemName || '-'}</div>
                              <div><span className="font-medium">Estado:</span> {a?.item?.status || '-'}</div>
                              <div><span className="font-medium">Usuario asignado:</span> {a?.item?.userAssigned?.name || '-'}</div>
                              {Array.isArray(a?.item?.media) && a?.item?.media?.length > 0 && (
                                <div className="mt-2">
                                  <div className="font-medium mb-1">Media</div>
                                  <div className="flex flex-wrap gap-2">
                                    {a.item.media.map((m, mIdx) => {
                                      const isImage = typeof m?.mimeType === 'string' && m.mimeType.startsWith('image/');
                                      return (
                                        <a
                                          key={m?.id || `${a.id}-media-${mIdx}`}
                                          href={m?.url || '#'}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="inline-flex items-center justify-center border border-gray-200 rounded-md p-1 hover:bg-gray-100 transition-colors"
                                          title={m?.filename}
                                        >
                                          {isImage ? (
                                            <img src={m.url} alt={m?.filename || 'media'} className="w-16 h-16 object-cover rounded" />
                                          ) : (
                                            <span className="px-2 py-1 text-gray-700 flex items-center gap-2">
                                              <FaFile /> {m?.filename || 'Archivo'}
                                            </span>
                                          )}
                                        </a>
                                      )
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Compra */}
                          <div className="bg-gray-50 rounded-lg p-3">
                            <h4 className="text-xs font-semibold text-gray-700 mb-2">Compra</h4>
                            <div className="text-[11px] grid grid-cols-2 gap-x-4 gap-y-1">
                              <div className="col-span-2 flex items-center gap-2">
                                <span className="font-medium">ID:</span>
                                <IdButton content={buy?.id || '-'} action={() => buy?.id && CopyToClipBoard(buy.id)} />
                              </div>
                              <div><span className="font-medium">Doc.:</span> {buy?.docType || '-'}</div>
                              <div><span className="font-medium">N°:</span> {buy?.receiptNumber || '-'}</div>
                              <div><span className="font-medium">Fecha pago:</span> {FormatDateToDDMMYY(buy?.paymentDate)}</div>
                              <div><span className="font-medium">Estado pago:</span> {buy?.paymentStatus || '-'}</div>
                              <div><span className="font-medium">Cantidad:</span> {buy?.quantity ?? '-'}</div>
                              <div><span className="font-medium">Moneda:</span> {buy?.currency || '-'}</div>
                              <div><span className="font-medium">Subtotal:</span> {currency} {formatMoney(buy?.subtotal)}</div>
                              <div><span className="font-medium">IGV:</span> {currency} {formatMoney(buy?.igv)}</div>
                              <div className="col-span-2"><span className="font-medium">Total:</span> {currency} {formatMoney(buy?.total)}</div>
                              <div className="col-span-2 mt-1"><span className="font-medium">Descripción:</span> {buy?.description || '-'}</div>
                            </div>
                          </div>
                            
                          {/* Actas y documentos */}
                          <div className="bg-gray-50 rounded-lg p-3">
                            <h4 className="text-xs font-semibold text-gray-700 mb-3">Actas y documentos</h4>
                            
                            {/* Acta de recepción */}
                            <div className="flex flex-row gap-2 items-center justify-start w-full mb-2">
                              <span className="text-xs text-gray-500 min-w-[120px]">Acta de recepción:</span>
                              {!a?.actaRecepcion ? (
                                <>
                                  <DinamicBoxButton
                                    content="Descargar"
                                    icon={<FaDownload className="text-[10px]" />}
                                    color="blue"
                                    size="sm"
                                    action={() => 
                                      a?.item?.media?.[0]?.url ?
                                      GenerateTxtFileAssignment({
                                        day: new Date().getDate(),
                                        monthName: new Date().toLocaleString('default', { month: 'long' }),
                                        year: new Date().getFullYear(),
                                        assignedWorker: a.user?.name,
                                        inventoryRegisterDate: a?.item?.createdAt,
                                        responsible: user.name,
                                        devolutionDate: new Date(),
                                        assignmentDate: a.dateStart,
                                        urlImage: a?.item?.media?.[0]?.url || '',
                                        currency: a?.item?.buy?.currency === "Soles" ? "S/." : "$",
                                        buyId: a?.item?.buy?.id,
                                        buyCode: a?.item?.buy?.receiptNumber,
                                        product: a?.item?.itemName,
                                        brand: a?.item?.buy?.stakeholder?.commercialName,
                                        price: a?.item?.buy?.stakeholderProduct?.price,
                                        buyDate: a?.item?.buy?.paymentDate,
                                        type: "recepción",
                                      }) : toast.warning('El ítem debe tener una imagen para generar el acta.')
                                    }
                                  />
                                  <div>
                                    <input
                                      type="file"
                                      id={`upload-acta-recepcion-individual-${a.id}`}
                                      className="hidden"
                                      accept="image/*,.pdf"
                                      disabled={uploadingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion'}
                                      onChange={(e) => handleUploadActaIndividual({ assignment: a, field: 'actaRecepcion', files: e.target.files })}
                                    />
                                    <DinamicBoxButton
                                      content="Subir"
                                      icon={uploadingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                                      disabled={uploadingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion'}
                                      color={uploadingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion' ? 'gray' : 'green'}
                                      size="sm"
                                      action={() => document.getElementById(`upload-acta-recepcion-individual-${a.id}`)?.click()}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <DinamicBoxButton
                                    content="Ver"
                                    icon={<FaExternalLinkAlt className="text-[10px]" />}
                                    color="blue"
                                    size="sm"
                                    action={() => {
                                      const url = a?.actaRecepcion?.url || a?.actaRecepcion?.[0]?.url
                                      if (url) window.open(url, '_blank')
                                      else toast.info('No hay acta de recepción')
                                    }}
                                  />
                                  <DinamicBoxButton
                                    action={() => deleteIndividualAssignmentActFile({ assignment: a, field: 'actaRecepcion', id: a?.actaRecepcion?.id })}
                                    content="Eliminar"
                                    icon={deletingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaTrash className="text-[10px]" />}
                                    disabled={deletingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion'}
                                    color={deletingRecepcionFile && assignUpdating === a.id && typeUpdating === 'actaRecepcion' ? 'gray' : 'red'}
                                    size="sm"
                                  />
                                </>
                              )}
                            </div>

                            {/* Acta de devolución */}
                            <div className="flex flex-row gap-2 items-center justify-start w-full">
                              <span className="text-xs text-gray-500 min-w-[120px]">Acta de devolución:</span>
                              {!a?.actaDevolucion ? (
                                <>
                                  <DinamicBoxButton
                                    content="Descargar"
                                    icon={<FaDownload className="text-[10px]" />}
                                    color="blue"
                                    size="sm"
                                    action={() => 
                                      a?.item?.media?.[0]?.url ?
                                      GenerateTxtFileAssignment({
                                        day: new Date().getDate(),
                                        monthName: new Date().toLocaleString('default', { month: 'long' }),
                                        year: new Date().getFullYear(),
                                        assignedWorker: a.user?.name,
                                        responsible: user.name,
                                        devolutionDate: new Date(),
                                        assignmentDate: a.dateStart,
                                        urlImage: a?.item?.media?.[0]?.url || '',
                                        currency: a?.item?.buy?.currency === "Soles" ? "S/." : "$",
                                        buyId: a?.item?.buy?.id,
                                        buyCode: a?.item?.buy?.receiptNumber,
                                        product: a?.item?.itemName,
                                        brand: a?.item?.buy?.stakeholder?.commercialName,
                                        price: a?.item?.buy?.stakeholderProduct?.price,
                                        buyDate: a?.item?.buy?.paymentDate,
                                        type: "devolución",
                                      }) : toast.warning('El ítem debe tener una imagen para generar el acta.')
                                    }
                                  />
                                  <div>
                                    <input
                                      type="file"
                                      id={`upload-acta-devolucion-individual-${a.id}`}
                                      className="hidden"
                                      accept="image/*,.pdf"
                                      disabled={uploadingDevolitionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion'}
                                      onChange={(e) => handleUploadActaIndividual({ assignment: a, field: 'actaDevolucion', files: e.target.files })}
                                    />
                                    <DinamicBoxButton
                                      content="Subir"
                                      icon={uploadingDevolitionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                                      disabled={uploadingDevolitionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion'}
                                      color={uploadingDevolitionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion' ? 'gray' : 'green'}
                                      size="sm"
                                      action={() => document.getElementById(`upload-acta-devolucion-individual-${a.id}`)?.click()}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <DinamicBoxButton
                                    content="Ver"
                                    icon={<FaExternalLinkAlt className="text-[10px]" />}
                                    color="blue"
                                    size="sm"
                                    action={() => {
                                      const url = a?.actaDevolucion?.url || a?.actaDevolucion?.[0]?.url
                                      if (url) window.open(url, '_blank')
                                      else toast.info('No hay acta de devolución')
                                    }}
                                  />
                                  <DinamicBoxButton
                                    action={() => deleteIndividualAssignmentActFile({ assignment: a, field: 'actaDevolucion', id: a?.actaDevolucion?.id })}
                                    content="Eliminar"
                                    icon={deletingDevolutionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaTrash className="text-[10px]" />}
                                    disabled={deletingDevolutionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion'}
                                    color={deletingDevolutionFile && assignUpdating === a.id && typeUpdating === 'actaDevolucion' ? 'gray' : 'red'}
                                    size="sm"
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-sm text-gray-600">Sin datos del bloque</div>
          )}
        </div>
      </Modal>

      <Modal
        activeModal={createBlockModal}
        onClose={() => setCreateBlockModal(false)}
        title="Crear bloque"
        centered
        className="max-w-8xl"
      >
        <div className="space-y-4">

          {/* Formulario de creación de bloque */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <TextInput title="Título" value={blockTitle} onChange={setBlockTitle} placeholder="Ej. Bloque Octubre" />
            <SelectInput title="Usuario responsable" value={blockUser} onChange={setBlockUser} options={workers} />
            <DateInput title="Fecha inicio" value={blockDateStart} onChange={setBlockDateStart} />
          </div>

          {/* Botones de la tabla de ítems disponibles */}
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-gray-700">Ítems disponibles</h3>
            <div className="flex gap-2">
              <ButtonInput content="Seleccionar todo" onClick={selectAllItems} color="gray" />
              <ButtonInput content="Limpiar" onClick={clearAllItems} color="gray" />
            </div>
          </div>

          {/* Tabla de ítems disponibles */}
          <div className="max-h-[50vh] overflow-y-auto border rounded">
            <table className="w-full text-xs">
              <thead className="sticky top-0 bg-gray-50">
                <tr>
                  <th className="text-left p-2 w-10">Seleccionar</th>
                  <th className="text-left p-2">Ítem</th>
                  <th className="text-left p-2">Proveedor</th>
                  <th className="text-left p-2">Compra</th>
                  <th className="text-left p-2">Fecha compra</th>
                  <th className="text-left p-2">Estado</th>
                  <th className="text-left p-2">Media</th>
                </tr>
              </thead>
              <tbody>
                {availableUnassignedItems.map((it) => (
                  <tr key={it.id} className="border-t">
                    <td className="p-2">
                      <CheckBox checked={selectedItemIds.includes(it.id)} action={() => toggleSelectItem(it.id)} />
                    </td>
                    <td className="p-2">{it.itemName}</td>
                    <td className="p-2">{it?.buy?.stakeholder?.commercialName || '-'}</td>
                    <td className="p-2">{it?.buy?.id || '-'}</td>
                    <td className="p-2">{FormatDateToDDMMYY(it?.buy?.paymentDate)}</td>
                    <td className="p-2">{it?.status || '-'}</td>
                    <td className="p-2">{it?.media?.length > 0 ? <img src={it?.media[0]?.url || '-'} alt={it?.itemName} className="w-4 h-4 rounded-sm" /> : '-'}</td>
                  </tr>
                ))}
                {availableUnassignedItems?.length === 0 && (
                  <tr>
                    <td className="p-4 text-center text-gray-500" colSpan={5}>No hay ítems sin asignar</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Paginador */}
          <div className="flex items-center justify-between text-xs">
            <SelectInput 
              title="Límite" 
              variant="horizontal"
              value={itemsLimit}                 
              onChange={async (e) => {
                const newLimit = Number(e.target.value)
                setItemsLimit(newLimit)
                setItemsPage(1)
                await loadUnassignedItems(1, newLimit)
              }} 
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
                { value: 50, label: "50" },
                { value: 100, label: "100" },
              ]} 
            />
            <div className="flex items-center gap-2">
              <PaginationItem
                variant="horizontal"
                actualDocs={availableUnassignedItems?.length || 0}
                totalDocs={itemsTotalDocs || 1}
                entity="ítems"
                totalPages={itemsTotalPages || 1}
                actualPage={itemsPage}
                handlePageChange={(e, value) => {
                  setItemsPage(value)
                  loadUnassignedItems(value, itemsLimit)
                }}
              />
            </div>
          </div>

          {/* Botones de creación de bloque */}
          <div className="flex items-center justify-end gap-2">
            <span className="text-xs text-gray-600 mr-auto">Seleccionados: {selectedItemIds?.length}</span>
            <ButtonInput content="Cancelar" onClick={() => setCreateBlockModal(false)} />
            <ButtonInput content="Crear bloque" onClick={createBlockWithAssignments} loading={creatingBlock} loadingContent="Creando..." color="green" /> 
          </div>
        </div>
      </Modal>

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaFile className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Bloques de asiganciones</h2>
          </div>
        </div>

        <div className="flex flex-row gap-8 items-center justify-center">

          <Selector
            title="Límite"
            setter={setLimit}
            value={limit}
            width="w-[5rem]"
            options={[
              { value: 20, label: "20" },
              { value: 30, label: "30" },
              { value: 40, label: "40" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
            ]}
          />

          <DinamicButton
            content="Crear bloque"
            icon={<FaPlus />}
            iconSize={10}
            action={openCreateBlockModal}
          />

        </div>

      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
        ) : (
          record?.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  {headers.filter((h) => h.show).map((h) => {
                    return (
                      <td key={h.id} className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                        {h.name}
                      </td>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {record.map((r, i) => {
                  return (
                    <tr key={r.id || i} className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
                      {headers.filter((h) => h.show).map((h, idx) => {
                        return (
                          <td key={h.id} className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                            {h.Cell({row: r, index: idx})}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Pagination */}
      <PaginationItem 
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"bloques"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(e, v) => setPage(v)}
      />
    </div>
  )
}

export default AsignacionesBloque;